import { Cell, Row, Spacer } from '../../../../components/ReusableComponents/Table'
import styles from './PMSBErow.module.scss'

const DoubleCellTitle = ({ primary, secondary, ...props }) => (
  <Cell className={styles.doubleCellTitle} {...props}>
    <div className={styles.doubleCellPrimary}>{primary}</div>
    <div className={styles.doubleCellSecondary}>avr. {secondary}</div>
  </Cell>
)

const TotalRow = ({ data = [], showTelcoDetails }) => {
  const count = data.length

  function generateTotalData() {
    const initialValue = {
      clicks: 0,
      conversions: 0,
      inviteFailedOther: 0,
      inviteFailedSpam: 0,
      invited: 0,
      optOut: 0,
      segmentInbound: 0,
      segmentOutbound: 0,
      textInbound: 0,
      textOutbound: 0,
      bookings: 0
    }

    if (data.length === 0 || !data) {
      return initialValue
    }

    return data.reduce(
      (prev, curr) => ({
        clicks: prev.clicks + curr.clicks.periodCurrent,
        conversions: prev.conversions + curr.conversions.periodCurrent,
        inviteFailedOther: prev.inviteFailedOther + curr.inviteFailedOther.periodCurrent,
        inviteFailedSpam: prev.inviteFailedSpam + curr.inviteFailedSpam.periodCurrent,
        invited: prev.invited + curr.invited.periodCurrent,
        optOut: prev.optOut + curr.optOut.periodCurrent,
        segmentInbound: prev.segmentInbound + curr.segmentInbound.periodCurrent,
        segmentOutbound: prev.segmentOutbound + curr.segmentOutbound.periodCurrent,
        textInbound: prev.textInbound + curr.textInbound.periodCurrent,
        textOutbound: prev.textOutbound + curr.textOutbound.periodCurrent,
        bookings: prev.bookings + curr.bookings.periodCurrent
      }),
      initialValue
    )
  }

  if (!data) {
    return null
  }

  const {
    clicks,
    conversions,
    inviteFailedOther,
    inviteFailedSpam,
    invited,
    optOut,
    segmentInbound,
    segmentOutbound,
    textInbound,
    textOutbound,
    bookings
  } = generateTotalData()

  const DoubleCell = ({ value, ...props }) => (
    <Cell className={styles.doubleCell} {...props}>
      <div className={styles.doubleCellPrimary}>{value}</div>
      <div className={styles.doubleCellSecondary}>avr. {Math.floor(value / count)}</div>
    </Cell>
  )

  return (
    <>
      {showTelcoDetails ? (
        <Row className={styles.totalRow}>
          <Spacer />
          <DoubleCellTitle primary="TOTAL" secondary={`For ${count} hotels`} />
          <DoubleCell value={clicks} />
          <DoubleCell value={invited} />
          <DoubleCell value={bookings} />
          <DoubleCell value={conversions} />
          <DoubleCell value={textInbound} />
          <DoubleCell value={textOutbound} />
          <DoubleCell value={optOut} />
          <DoubleCell value={segmentInbound} />
          <DoubleCell value={segmentOutbound} />
          <DoubleCell value={inviteFailedSpam} />
          <DoubleCell value={inviteFailedOther} />
        </Row>
      ) : (
        <Row className={styles.totalRow}>
          <Spacer />
          <DoubleCellTitle primary="TOTAL" secondary={`For ${count} hotels`} />
          <DoubleCell value={clicks} />
          <DoubleCell value={invited} />
          <DoubleCell value={bookings} />
          <DoubleCell value={conversions} />
          <Spacer />
          <Spacer />
          <Spacer />
          <Spacer />
          <Spacer />
          <Spacer />
        </Row>
      )}
    </>
  )
}

export default TotalRow
